module.exports = __webpack_public_path__ + "static/media/hire.6b2601a3.svg";